import { slugify } from "./slugify"

export const createJobSlug = (id = "", title = "") => {
    return `details/${slugify(title)}/${id}`
}